.as{flex-shrink:0;}